<div class="col-md-12 col-lg-12">
  <span class="dashboardHeader">Outgoing funds</span>
  <div class="pie-title" style="align-content: center">
    <div class="chart-container">
      <ngx-charts-pie-chart
        [view]="view"
        [scheme]="outGoingFunds"
        [results]="outgoingFundDetails"
        [doughnut]="true"
        class="hide-tooltip"
      >
      </ngx-charts-pie-chart>
      <div class="center-text">
        <div class="text-style text-center">Total outgoing</div>
        <div class="text-value text-center">
          $ {{ totalTransfers?.value + totalCashout?.value | number : "1.2-2" }}
        </div>
      </div>
    </div>
    <div>
      <div class="mb-2">
        <div class="graphDetails">
          <div class="cashout"></div>
          <div class="ml-2">
            <div class="text-label mb-0">{{ totalCashout.name }}</div>
            <div class="text-label-value">
              {{ totalCashout?.currency }}
              {{ totalCashout?.value | number : "1.2-2" }} ({{
                totalCashout?.percent
              }}%)
            </div>
          </div>
        </div>
        <div class="graphDetails mt-4">
          <div class="transfers"></div>
          <div class="ml-2">
            <div class="text-label mb-0">{{ totalTransfers.name }}</div>
            <div class="text-label-value">
              {{ totalTransfers?.currency }}
              {{ totalTransfers?.value | number : "1.2-2" }} ({{
                totalTransfers?.percent
              }}%)
            </div>
          </div>
        </div>
      </div>
      <div class="ml-4 mt-4">
        <div class="text-label mb-0">No. of beneficiaries</div>
        <div class="text-label-value">{{ USERS_COUNT }}</div>
      </div>
    </div>
  </div>
</div>
